export default __webpack_public_path__ + "static/media/Fonciere Signature.3b60bb5c.mp4";